import { get } from '@alltrails/shared/api';
import SubscriptionsNewResponse from '@alltrails/core/types/SubscriptionsNewResponse';

export default async function getSubscriptionsNew() {
  return get<SubscriptionsNewResponse>(`/api/alltrails/purchases/subscriptions/new`);
}
